import {
  DownloadOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  FileTextOutlined,
} from '@ant-design/icons';
import { Button, Card } from 'antd';
import React from 'react';
import styles from './Metocean.module.scss';
import { PDFPreviewCover } from './PDFPreviewCover';

export interface ISampleReport {
  id: string;
  title: string;
  pdfUrl: string;
  thumbnailUrl: string;
  zipUrl: string;
}

interface ReportCardProps {
  report: ISampleReport;
  onPdfDownload: (report: ISampleReport) => void;
  onExcelDownload: (report: ISampleReport) => void;
}

export const ReportCard: React.FC<ReportCardProps> = ({
  report,
  onPdfDownload,
  onExcelDownload,
}) => {
  return (
    <div style={{ border: '1px solid #eee', borderRadius: '2px' }}>
      <Card
        bordered={false}
        cover={
          <PDFPreviewCover
            onPdfDownload={() => onPdfDownload(report)}
            thumbnailUrl={report.thumbnailUrl}
            title={report.title}
          />
        }
      >
        <Card.Meta
          className={styles.customCardMeta}
          avatar={<FileTextOutlined style={{ fontSize: '17px' }} />}
          title={<span style={{ textAlign: 'left' }}>{report.title}</span>}
        />
        <div style={{ marginTop: '16px', display: 'flex', gap: '8px' }}>
          <Button
            type='default'
            icon={<FilePdfOutlined />}
            onClick={() => onPdfDownload(report)}
            style={{ color: '#0099ff' }}
            block
          >
            PDF
            <DownloadOutlined />
          </Button>
          <Button
            type='default'
            icon={<FileExcelOutlined />}
            onClick={() => onExcelDownload(report)}
            style={{ color: '#0099ff' }}
            block
          >
            Excel
            <DownloadOutlined />
          </Button>
        </div>
      </Card>
    </div>
  );
};
